// Slider prev/next — wires [data-slider="<id>"] with [data-slider-prev="<id>"] / [data-slider-next="<id>"].
function initSliders() {
  document.querySelectorAll('[data-slider]').forEach(slider => {
    const id = slider.getAttribute('data-slider');
    const prev = document.querySelector(`[data-slider-prev="${id}"]`);
    const next = document.querySelector(`[data-slider-next="${id}"]`);
    const scrollByOne = (dir) => {
      const first = slider.querySelector(':scope > *');
      if (!first) return;
      const cs = getComputedStyle(slider);
      const gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
      const step = first.getBoundingClientRect().width + gap;
      slider.scrollBy({ left: dir * step, behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', () => scrollByOne(-1));
    if (next) next.addEventListener('click', () => scrollByOne(1));
  });
}

if (document.readyState !== 'loading') initSliders();
else document.addEventListener('DOMContentLoaded', initSliders);
